angular.module('dpw.services')
    .factory('firstTimeLogin', ['$rootScope', '$q', 'popup', 'api', 'myAccountUtils', 'mixpanelService', 'helpers', 'preLoader', 'organizationService', function ($rootScope, $q, popup, api, myAccountUtils, mixpanelService, helpers, preLoader, organizationService) {
            /**
             * @param {Object} options
             * @param {Function} options.agree
             * @param {Function} options.deny
             * @param {Object} options.user
             */
            return function (options) {
                var agreedHandler = options.agree || angular.noop;
                var denyHandler = options.deny || angular.noop;
                var newScope = $rootScope.$new();

                newScope.callback = afterAgreementHandle;
                newScope.user = options.user || {};
                newScope.$on('popupDestroy', deny);
                popup({
                    scope: newScope,
                    directiveName: 'dpw-first-login-agreement',
                    extraClass: 'dpw-first-login-agreement-popup',
                    showCloseBtn: false,
                    showHeader: false,
                });

                function afterAgreementHandle(agreed) {
                    if (agreed) {
                        api.call(api.acceptTerms(), function (res) {

                            // @see DPW-7967
                            // Since the mission of the toc popup has been completed.
                            newScope.$destroy();

                            myAccountUtils.getDevelopers({
                                onSuccess: function (data) {
                                    var developer = data.developer;
                                    var organization = data.organization;
                                    mixpanelService.alias(developer);

                                    // @see DPW-7967
                                    // Prevent users from accidental interaction with the UI,
                                    //     since the mixpanel invocations require time and don't have a pre-loader.
                                    preLoader.show();

                                    mixpanelService.setPeopleProperty({
                                        '$distinct_id': developer.rcExtensionId,
                                        'Org Type': organization.type,
                                        'Org Link': helpers.getAdminSiteUrl('orgDetail', {
                                            orgId: organization.id
                                        })
                                    }).then(function () {
                                        return organizationService.getHashedAccountId().then(function (hashedAccountId) {
                                            if (hashedAccountId) {
                                                return mixpanelService.set_group(hashedAccountId);
                                            }
                                        });
                                    }).then(function () {
                                        return mixpanelService.performTracking(mixpanelService.eventNames.DEV_FIRST_LOGIN, {
                                            'Org Type': organization.type
                                        });
                                    }).then(function () {
                                        agreedHandler(res.user);
                                    });
                                }
                            });
                        });
                    } else {
                        deny();
                    }
                }

                function deny() {
                    $.removeCookie('IS_LOGIN', {path: '/'});
                    newScope.$destroy();
                    denyHandler();
                    $q.all([
                        api.threeLogout(),
                        api.logout()
                    ]).then(function () {
                        window.location = '/';
                    });
                }
            };
        }]
    );

angular.module('dpw.directives').directive('dpwFirstLoginAgreement', ['user', function (userService) {
        return {
            restrict: 'A',
            controller: ['$scope', function ($scope) {
                var self = this;
                var user = userService.process($scope.user);

                this.agreementMark = false;
                this.termsAndConditionsMark = false;
                this.agreed = this.agreementMark;
                this.isPartner = user.isPartner;
                this.onMarkChange = function () {
                    self.agreed = self.agreementMark;
                    if (this.brandTNCEnabled()) {
                        self.agreed = self.agreed & self.termsAndConditionsMark;
                    }
                };
                this.brandTNCEnabled = function () {
                    return user.isPartner && this.hasBrandTNC;
                };
                this.disagree = function () {
                    self.agreed && $scope.callback(false);
                };
                this.agree = function () {
                    self.agreed && $scope.callback(true);
                };

                if (user.isPartner) {
                    var ATTTerms = {
                        label: 'Terms of Service',
                        link: 'https://www.att.com/officeathandpolicy'
                    };
                    var termsAndConditions = {
                        3420: ATTTerms,
                        3460: ATTTerms,
                        7310: {
                            label: 'Service Terms',
                            link: 'https://business.telus.com/en/support/global/legal/business-connect-service-terms?INTCMP=VAN_businessconnect_serviceterms'
                        },
                        7710: {
                            label: 'Terms & conditions',
                            link: 'https://business.bt.com/products/terms-of-use/'
                        },
                        6010: {
                            label: 'Terms of Service',
                            link: 'https://www.ringcentral.com/legal/eulatos.html'
                        },
                        2020: {
                            label: 'Terms of Service',
                            link: 'https://www.ringcentral.com/legal/a/legal.html'
                        },
                        2110: {
                            label: 'Terms of Service',
                            link: 'https://www.ringcentral.com/legal/eulatos.html'
                        },
                        2210: {
                            label: 'Terms of Service',
                            link: 'https://www.verizon.com/about/terms-conditions/business-terms-of-service'
                        },
                        7010: {
                            label: 'Terms of Service',
                            link: 'https://www.vodafone.co.uk/terms-and-conditions/'
                        },
                        4210: {
                            label: 'Terms of Service',
                            link: 'https://www.ecotel.de/footer-navigation/rechtliche-hinweise/agb'
                        },
                        4810: {
                            label: 'Terms of Service',
                            link: 'https://www.mcmtelecom.com/hubfs/2107_symphonyRc/CONTRATO-MARCO-RC-2021.pdf'
                        },
                        4610: {
                            label: 'Terms of Service',
                            link: 'https://www.eastlink.ca/about/terms-and-conditions'
                        },
                        4710: {
                            label: 'Terms of Service',
                            link: 'https://www.1und1.net/agb',
                        },
                        2030: {
                            label: 'Terms of Service',
                            link: 'https://www.telekom.de/is-bin/INTERSHOP.enfinity/WFS/EKI-PK-Site/-/-/-/ViewAGB-TextQuery?SearchText=&wt_mc=alias_1156_agb',
                        },
                        2040: {
                            label: 'Terms of Service',
                            link: 'https://www.telekom.de/is-bin/INTERSHOP.enfinity/WFS/EKI-PK-Site/-/-/-/ViewAGB-TextQuery?SearchText=&wt_mc=alias_1156_agb',
                        },
                        4910: {
                            label: 'Terms of Service',
                            link: 'https://frontier.com/corporate/terms',
                        },
                        2050: {
                            label: 'Terms of Service',
                            link: 'https://www.sunrise.ch/en/residential/help/sonstige-hilfe/rechtliches.html',
                        },
                        5110: {
                            label: 'Terms of Service',
                            link: 'https://www.spectrum.com/policies/terms-of-service',
                        },
                        5210: {
                            label: 'Terms of Service',
                            link: 'https://www.spectrum.com/policies/terms-of-service',
                        },
                    };
                    var brandTNC = termsAndConditions[user.brand.id];
                    this.hasBrandTNC = !!brandTNC;

                    this.termsAndConditionsText = brandTNC ? [
                        user.brand.name,
                        '<a href="' + brandTNC.link + '" target="_blank" class="agreement-link">' + brandTNC.label + '</a>'
                    ].join(' ') : '';
                }
            }],
            controllerAs: 'ctrl',
            templateUrl: 'dpw-first-login-agreement.html'
        };
    }]
);
